module.exports = __webpack_public_path__ + "static/media/game-Rdooropen.689ca574.png";